import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserAnimationDemo from 'src/games/demos/phaserAnimationDemo/Main';

interface AnimationDemoProps extends PageProps<{}> {
}

class AnimationDemo extends React.Component<AnimationDemoProps> {
    constructor(props: AnimationDemoProps) {
        super(props);
        bindAllOfThis(this, AnimationDemo.prototype);
    }

    render() {
        return (<div>
            <PhaserAnimationDemo />
        </div>);
    }
}

export default AnimationDemo;



// WEBPACK FOOTER //
// ./src/pages/game/demos/AnimationDemo.tsx